import { create } from "zustand";
import type { SlideImageResult } from "@/utils/slideUtils";

export type SlideEditSidebarSelection = "slide-edit" | "price-refresh";

export type SlideEditSelection = { index: number; slideId: string };

export type SlideEditTypeId =
  | "chart-time-period-price-refresh"
  | "chart-relative-benchmarks"
  | "chart-customization-options"
  | "text-on-slide";

interface SlideEditPopupState {
  sidebar: SlideEditSidebarSelection;
  setSidebar: (value: SlideEditSidebarSelection) => void;
  showSidebar: boolean;
  setShowSidebar: (value: boolean) => void;
  selectedSlideForEdit: SlideEditSelection | null;
  setSelectedSlideForEdit: (value: SlideEditSelection | null) => void;
  /** Multi-select: which edit types apply to the selected slide */
  selectedSlideEditTypeIds: SlideEditTypeId[];
  toggleSlideEditTypeId: (id: SlideEditTypeId) => void;
  clearSlideEditTypeSelection: () => void;
  slideThumbnails: SlideImageResult[] | null;
  setSlideThumbnails: (slides: SlideImageResult[] | null) => void;
}

export const useSlideEditStore = create<SlideEditPopupState>((set) => ({
  sidebar: "slide-edit",
  setSidebar: (value) => set({ sidebar: value }),
  showSidebar: true,
  setShowSidebar: (value) => set({ showSidebar: value }),
  selectedSlideForEdit: null,
  setSelectedSlideForEdit: (value) => set({ selectedSlideForEdit: value }),
  selectedSlideEditTypeIds: [],
  toggleSlideEditTypeId: (id) =>
    set((state) => {
      const has = state.selectedSlideEditTypeIds.includes(id);
      return {
        selectedSlideEditTypeIds: has
          ? state.selectedSlideEditTypeIds.filter((x) => x !== id)
          : [...state.selectedSlideEditTypeIds, id],
      };
    }),
  clearSlideEditTypeSelection: () => set({ selectedSlideEditTypeIds: [] }),
  slideThumbnails: null,
  setSlideThumbnails: (slides) => set({ slideThumbnails: slides }),
}));
